import { connect } from 'react-redux';
import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { isFeatureEnabled } from 'common/trunk-features/store/selectors';
import { isAppointmentMessageLogAccessible } from './appointmentMessageLogAccess';

import { Marketing as Component, TABS } from './index';
import { CLIENT_APP_ENABLED_CHANNEL_FEATURE } from './chnlFeatures';
import { isWebviewSelector } from 'reduxStore/common/appSettings/selectors';

export const resolveDefaultTab = ({ tab }) => {
  // The tab parameter here comes from the backbone router,
  // e.g if user comes through direct link to the specific tab
  if (tab) return tab;
  return TABS.AUTOMATED_MESSAGING;
};

const mapStateToProps = (state, ownProps) => {
  const isEmailCampaignsAccessible = Wahanda.Permissions.anyEmailCampaignEnabled();
  const isClientFormsAccessible = isFeatureEnabled(state, 'CAR-2635-client-forms-page');
  const isClientAppEnabled =
    App.isFeatureSupported(CLIENT_APP_ENABLED_CHANNEL_FEATURE) && App.isVenueListedOnMarketplace();
  const isPartnerSiteAccessible = Wahanda.Permissions.canAccessPartnerSites();

  const defaultTab = resolveDefaultTab(ownProps);

  return {
    defaultTab,
    hideSidebar: isWebviewSelector(state),
    isClientAppEnabled,
    isClientFormsAccessible,
    isEmailCampaignsAccessible,
    isPartnerSiteAccessible,
    isAppointmentMessageLogAccessible: isAppointmentMessageLogAccessible(state),
  };
};

export const Marketing = connect(mapStateToProps)(Component);
